import { readPacket, writePacket } from '../core/packets'

export class SocketRemote {
  constructor(wsUrl, params) {
    this.wsUrl = wsUrl
    this.params = params
    this.receiver = null
  }

  setReceiver(receiver) {
    this.receiver = receiver
  }

  connect() {
    const url = new URL(this.wsUrl)
    for (const key in this.params) {
      url.searchParams.set(key, this.params[key])
    }
    this.ws = new WebSocket(url.toString())
    this.ws.binaryType = 'arraybuffer'
    this.ws.addEventListener('message', this._onPacket)
    this.ws.addEventListener('close', this._onClose)
  }

  send(name, data) {
    const packet = writePacket(name, data)
    this.ws.send(packet)
  }

  _onPacket = e => {
    const msg = readPacket(e.data)
    this.receiver.onPacket(msg)
  }

  _onClose = e => {
    this.ws.removeEventListener('message', this._onPacket)
    this.ws.removeEventListener('close', this._onClose)
    this.ws = null
    const code = e?.code || null
    const reason = e?.reason || null
    this.receiver.onClose(code, reason)
  }
}
